var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('cube-tab-bar',{on:{"click":_vm.changHandler},model:{value:(_vm.selectedLabelSlots),callback:function ($$v) {_vm.selectedLabelSlots=$$v},expression:"selectedLabelSlots"}},_vm._l((_vm.tabs),function(item){return _c('cube-tab',{key:item.path,attrs:{"icon":item.icon,"label":item.label,"value":item.path}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }